import mhead from 'mhead-js';
$(window).on('load', function() {
	const mobileHeader = $('.mobile-header').mhead({
		scroll: {
			tolerance: 1
		}
	});
});
